<!-- 赏罚通报 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('填报部门')">
              <j-select-depart v-model="queryParam.departId" :multi="false"></j-select-depart>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="announceSecondName" slot-scope="text,record">
          <a-tag color="green" v-if="text == '奖励通报'">{{ $t('奖励通报') }}</a-tag>
          <a-tag color="red" v-else>{{ $t('罚款通报') }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <template v-if="record.bpmStatus == 0">
            <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
            <a-divider type="vertical" />
            <a @click="handleRelease(record)">{{ $t('发布') }}</a>
            <a-divider type="vertical" />
          </template>
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from './rewardAndPunishmentNotificationModal'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      JSelectDepart
    },
    data () {
      return {
        url: {
          list: "/jeecg-oa/notice/bsAnnounce/list",
          delete: "/jeecg-oa/notice/bsAnnounce/delete",
          deleteBatch: "/jeecg-oa/notice/bsAnnounce/deleteBatch",
          updateState: "/jeecg-oa/notice/bsAnnounce/updateState",
        },
        dictOptions:{},
        superFieldList:[],
        queryParam:{
          announceFirstType:3
        }
      }
    },
    created() {},
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('通报类型'),
            align:"center",
            dataIndex: 'announceSecondName',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'announceSecondName' }
          },
          {
            title: this.$t('通报标题'),
            align:"center",
            dataIndex: 'announceTitle',
            width:300,
            ellipsis: true,
          },
          {
            title: this.$t('填报部门'),
            align:"center",
            dataIndex: 'departName',
            width:150,
            ellipsis: true,
          },
          // {
          //   title:'附件',
          //   align:"center",
          //   dataIndex: 'files',
          //   scopedSlots: { customRender: 'fileSlot' }
          // },
          {
            title: this.$t('优先级'),
            align:"center",
            dataIndex: 'priority',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('流程状态'),
            align:"center",
            dataIndex: 'bpmStatus',
            customRender: (t, r, index) => {
              if(t == 0){
                return this.$t('草稿')
              }else{
                return this.$t('发布')
              }
            },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('更新时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ];
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      searchReset(){
        this.queryParam = {
          announceFirstType:3
        };
        this.loadData();
      },
      handleAdd(){
        this.$nextTick(()=>{
          this.$refs.modalForm.init({});
        });
      },
      handleEdit(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'edit');
        });
      },
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'detail');
        });
      },
      handleRelease(row){
        postAction(this.url.updateState,row).then(res=>{
          if(res.success){
            this.$message.success(this.$t('发布成功'));
            this.loadData();
          }else{
            this.$message.error(this.$t('操作失败'));
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>